import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Shimmer from './Shimmer';

// Skeleton for the Specials grid. Mirrors the real offer card:
//   sage gradient top stripe · amber badge (top-right abs) · emoji icon ·
//   title · 1–2 line description · validity line · big forest price row
//   (+ strikethrough) · primary CTA.
// Only the grid itself is a shimmer — the forest hero + eyebrow + filter
// pills render immediately since they don't depend on the offers fetch.

const OfferCardShimmer = () => (
  <Box
    sx={{
      bgcolor: '#fff',
      border: '1.5px solid var(--border-l)',
      borderRadius: '20px',
      p: { xs: 2.5, md: 3.25 },
      position: 'relative',
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0, left: 0, right: 0,
        height: 4,
        background: 'linear-gradient(90deg, var(--sage), var(--sage-p))',
      },
    }}
  >
    {/* Badge placeholder */}
    <Shimmer
      width={68}
      height={20}
      rounded={100}
      sx={{ position: 'absolute', top: 14, right: 14 }}
    />

    {/* Emoji icon */}
    <Shimmer width={40} height={40} rounded={8} sx={{ mb: 1.5 }} />

    {/* Title (2 lines) */}
    <Shimmer width="85%" height={14} rounded={4} sx={{ mb: 0.75 }} />
    <Shimmer width="55%" height={14} rounded={4} sx={{ mb: 1.25 }} />

    {/* Description (2 lines) */}
    <Shimmer width="95%" height={11} rounded={4} sx={{ mb: 0.75 }} />
    <Shimmer width="75%" height={11} rounded={4} sx={{ mb: 1.5 }} />

    {/* Validity + campaign line */}
    <Shimmer width="60%" height={11} rounded={4} sx={{ mb: 2 }} />

    {/* Price row */}
    <Stack direction="row" alignItems="baseline" spacing={1} sx={{ mb: 2, mt: 'auto' }}>
      <Shimmer width={110} height={28} rounded={6} />
      <Shimmer width={54} height={12} rounded={4} />
    </Stack>

    {/* CTA */}
    <Shimmer width="100%" height={40} rounded={100} />
  </Box>
);

const SpecialsShimmer = ({ count = 6 }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
      gap: { xs: 2, md: 2.5 },
      width: '100%',
    }}
  >
    {Array.from({ length: count }).map((_, i) => <OfferCardShimmer key={i} />)}
  </Box>
);

export default SpecialsShimmer;
